var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstockLogoBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_8738_45764)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8577 22.5L39.2558 22.5L29.5504 22.5L29.5504 33.3513L40.204 33.3512L37.6841 39.8927C41.0643 37.0117 47.8252 32.9755 56.1702 33.1889L62.4813 33.1889L62.5078 22.5L60.4775 22.5L50.8577 22.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1614 42.1317C45.2881 36.7965 51.0821 35.8594 57.0134 35.8594H62.5063L62.5062 52.4778L51.6497 52.4794V46.6592C44.2448 46.7364 32.4688 51.629 29.5488 66.8708C29.5488 54.9833 33.3326 47.2074 39.1614 42.1317Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6342 66.445C29.6043 66.6416 29.5759 66.8397 29.5488 67.0396H40.3234C40.3234 59.384 42.7467 48.2547 51.6149 46.6641C44.2783 46.7553 32.6867 51.5647 29.6342 66.445Z",
    fill: "#C2C7ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8738_45764",
    x1: 113.571,
    y1: 109.286,
    x2: 21.3164,
    y2: 19.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#11193C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4559B7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstockLogoBadge);
export default __webpack_public_path__ + "static/media/firstockLogoBadge.1dc9d7481f1a9020200191e36800efd1.svg";
export { ForwardRef as ReactComponent };